<template>
  <ValidationObserver v-slot="{ handleSubmit }">
    <form @submit.prevent="handleSubmit(updateUniversity)">
      <md-card>
        <md-card-header
          class="md-card-header-icon"
          :class="getClass(headerColor)"
        >
          <div class="card-icon">
            <md-icon>account_balance</md-icon>
          </div>
          <h4 class="title">Candidate Form - <small>Update</small></h4>
        </md-card-header>

        <md-card-content>
          <div class="md-layout">
            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="first_name"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>account_balance</md-icon>
                  <label>First Name</label>
                  <md-input v-model="first_name" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="last_name"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>account_balance</md-icon>
                  <label>Last Name</label>
                  <md-input v-model="last_name" type="text"></md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="email"
                rules="email"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[
                    { 'md-error': failed },
                    { 'md-valid': passed },
                    { 'md-form-group': true }
                  ]"
                >
                  <md-icon>email</md-icon>
                  <label>Email</label>
                  <md-input v-model="email" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="candidate_from"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>From</label>
                  <md-select v-model="candidate_from" name="type">
                    <md-option value="">Select</md-option>
                    <md-option value="facebook">Facebook</md-option>
                    <md-option value="instagram">Instagram</md-option>
                    <md-option value="website">Website</md-option>
                    <md-option value="phone">Phone</md-option>
                    <md-option value="Other">Other</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="program"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[
                    { 'md-error': failed },
                    { 'md-valid': passed },
                    { 'md-form-group': true }
                  ]"
                >
                  <md-icon>email</md-icon>
                  <label>Program</label>
                  <md-input v-model="program" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="nationality"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Nationality</label>
                  <md-select v-model="nationality" name="nationality">
                    <md-option value="">Select Country</md-option>
                    <md-option
                      v-for="c in countries"
                      v-bind:key="c.id"
                      :value="c.id"
                    >
                      {{ c.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="country_of_residence"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Country of Residence</label>
                  <md-select
                    v-model="country_of_residence"
                    name="country_of_residence"
                  >
                    <md-option value="">Select Country</md-option>
                    <md-option
                      v-for="c in countries"
                      v-bind:key="c.id"
                      :value="c.id"
                    >
                      {{ c.name }}
                    </md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="phone_number"
                rules="numeric|required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>phone</md-icon>
                  <label>Phone Number</label>
                  <md-input v-model="phone_number" type="text"> </md-input>

                  <slide-y-down-transition>
                    <md-icon class="error" v-show="failed">close</md-icon>
                  </slide-y-down-transition>
                  <slide-y-down-transition>
                    <md-icon class="success" v-show="passed">done</md-icon>
                  </slide-y-down-transition>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="university_type"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>University Type</label>
                  <md-select v-model="university_type" name="type">
                    <md-option value="">Select Type</md-option>
                    <md-option value="1">State</md-option>
                    <md-option value="2">Private</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="university_degree"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>add_location</md-icon>
                  <label>Degree</label>
                  <md-select v-model="university_degree" name="type">
                    <md-option value="">Select Degree</md-option>
                    <md-option value="1">Associate degree</md-option>
                    <md-option value="2">Bachelor degree</md-option>
                    <md-option value="3">Master Non-Thesis</md-option>
                    <md-option value="4">Master With Thesis</md-option>
                    <md-option value="5">Phd degree</md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="education_language"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>leaderboard</md-icon>
                  <label>Education Language</label>
                  <md-select
                    v-model="education_language"
                    name="education_language"
                  >
                    <md-option value="">Select Language</md-option>
                    <md-option value="Turkish">Turkish</md-option>
                    <md-option value="English">English</md-option>
                    <md-option value="Arabic">Arabic</md-option>
                    <md-option value="Russian">Russian</md-option>
                    <md-option value="Spanish">Spanish</md-option>
                    <md-option value="French">French</md-option>
                    <md-option value="German">German</md-option>
                    <md-option value="%30 English %70 Turkish"
                      >%30 English %70 Turkish
                    </md-option>
                    <md-option value="%50 English %50 Turkish"
                      >%50 English %50 Turkish
                    </md-option>
                    <md-option value="%30 Arabic %70 Turkish"
                      >%30 Arabic %70 Turkish
                    </md-option>
                    <md-option value="%30 German %70 Turkish"
                      >%30 German %70 Turkish
                    </md-option>
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-50 md-small-size-100">
              <ValidationProvider
                name="authorized_user"
                rules="required"
                v-slot="{ passed, failed }"
              >
                <md-field
                  :class="[{ 'md-error': failed }, { 'md-valid': passed }]"
                >
                  <md-icon>person</md-icon>
                  <label>Authorized user</label>
                  <md-select v-model="authorized_user" name="authorized_user">
                    <md-option value="">Select User</md-option>
                    <md-option
                      v-for="c in users"
                      v-bind:key="c.id"
                      :value="c.id"
                      >{{ c.first_name }} {{ c.last_name }}</md-option
                    >
                  </md-select>
                </md-field>
              </ValidationProvider>
            </div>

            <div class="md-layout-item md-size-100 text-right">
              <md-button type="submit" class="md-raised md-success mt-4"
                >Update Candidate Form
              </md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </ValidationObserver>
</template>
<script>
import { SlideYDownTransition } from "vue2-transitions";
import { extend } from "vee-validate";
import { required, numeric, email } from "vee-validate/dist/rules";

extend("required", required);
extend("numeric", numeric);
extend("email", email);

export default {
  components: {
    SlideYDownTransition
  },
  props: {
    headerColor: {
      type: String,
      default: ""
    },
    avatar: {
      type: String,
      default: "/img/image_placeholder.jpg"
    }
  },
  data() {
    return {
      candidateID: null,
      countries: [],
      users: [],

      first_name: null,
      last_name: null,
      email: null,
      candidate_from: null,
      program: null,
      nationality: null,
      country_of_residence: null,
      phone_number: null,
      university_type: null,
      university_degree: null,
      education_language: null,
      authorized_user: null
    };
  },
  methods: {
    getClass: function(headerColor) {
      return "md-card-header-" + headerColor + "";
    },
    handlePreview(file) {
      this.model.imageUrl = URL.createObjectURL(file.raw);
    },
    onFileChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) return;
      this.logo = files[0];
      this.createImage(files[0]);
    },
    createImage(file) {
      var reader = new FileReader();
      var vm = this;

      reader.onload = e => {
        vm.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
    updateUniversity() {
      let data = {
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        candidate_from: this.candidate_from,
        program: this.program,
        nationality: this.nationality,
        country_of_residence: this.country_of_residence,
        phone_number: this.phone_number,
        university_type: this.university_type,
        university_degree: this.university_degree,
        education_language: this.education_language,
        authorized_user: this.authorized_user
      };
      var post_data = {};
      for (const field in data) {
        if (data[field] instanceof Date) {
          post_data[field] = data[field]
            .toLocaleDateString("ko-KR")
            .replaceAll(". ", "-")
            .replaceAll(".", "");
        } else {
          if (field === "discounted_price" && data[field] === "") {
            post_data[field] = null;
          } else {
            post_data[field] = data[field];
          }
        }
      }
      this.$store
        .updateCandidate(post_data, this.candidateID)
        .then(response => {
          this.$notify({
            message: "Candidate Form updated.",
            icon: "add_alert",
            type: "success",
            verticalAlign: "top",
            timeout: 3000
          });
        })
        .catch(error => {
          var message = error.response.data;
          this.$notify({
            message: JSON.stringify(message),
            icon: "add_alert",
            type: "warning",
            verticalAlign: "top",
            timeout: 3000
          });
        });
    }
  },
  mounted() {
    this.candidateID = this.$route.params.id;
    this.$store
      .getCountries()
      .then(response => {
        this.countries = response.data.results;
      })
      .catch(error => {
        this.$notify({
          message: error.message,
          icon: "add_alert",
          type: "warning",
          verticalAlign: "top"
        });
      });
    const default_user = {
      id: this.$store.user_id,
      first_name: this.$store.first_name,
      last_name: this.$store.last_name
    };
    // admin user
    let role = 1;
    this.$store
      .getUsers(role, { title: "Counselor" })
      .then(response => {
        this.users = response.data.results;
        this.users.push(default_user);
      })
      .catch(error => {
        this.users.push(default_user);
      });
  }
};
</script>
<style>
.picture input[type="file"] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}
</style>
